import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import CmsInlineEdit from '../../../components/Cms/CmsInlineEdit';
import { createMarkdownComponents, findCmsNode } from '../helpers';

const OrderYourWaySection = ({ orderYourWaySection, onButtonClick }) => {
  if (!orderYourWaySection || !orderYourWaySection.orderCards || orderYourWaySection.orderCards.length === 0) {
    return null;
  }

  const titleNode = findCmsNode(orderYourWaySection.cmsNode, 'title');

  return (
    <section className="pt-16 pb-8">
      <div className="px-4 xl:px-0 w-full max-w-screen-desktop mx-auto">
        <div>
          <h2 className="font-aryaDouble !font-normal text-[38px] leading-[38px] tracking-[-1px] text-center mb-4 text-white">
            <CmsInlineEdit cmsNode={titleNode || null}>
              {orderYourWaySection.title}
            </CmsInlineEdit>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 xl:gap-6 max-w-7xl mx-auto">
            {orderYourWaySection.orderCards.map((card, index) => (
              <div key={card.cmsKeyId || index} className="flex flex-col rounded-xl xl:rounded-[20px] overflow-hidden hover:shadow-lg transition-shadow duration-300 border-2 border-[#846C92] p-4">
                {card.image && (
                  <CmsInlineEdit
                    cmsNode={findCmsNode(card.cmsNode, 'image')}
                    applyMarkdown={false}
                    applyMarkdownOnEdit={false}
                  >
                    <ReactMarkdown
                      components={createMarkdownComponents('w-full object-cover rounded-xl xl:rounded-[20px] align-middle aspect-[352/280]')}
                    >
                      {card.image}
                    </ReactMarkdown>
                  </CmsInlineEdit>
                )}
                <div className="flex flex-col flex-grow py-4 items-center">
                  <h3 className="font-congenialBlack font-black text-[28px] leading-7 tracking-[-0.2px] text-white mb-3">
                    <CmsInlineEdit cmsNode={findCmsNode(card.cmsNode, 'title')}>
                      {card.title}
                    </CmsInlineEdit>
                  </h3>
                  <p className="font-montserratMedium text-center text-[#B4A5BB] mb-3 text-lg font-medium leading-[22px] tracking-[-0.1px]">
                    <CmsInlineEdit cmsNode={findCmsNode(card.cmsNode, 'description')}>
                      {card.description}
                    </CmsInlineEdit>
                  </p>
                  <CmsInlineEdit
                    type="list"
                    cmsNode={card.buttonNode || null}
                    showContent={false}
                    showChilds
                  >
                    <button
                      type="button"
                      onClick={() => onButtonClick(card.buttonLink, card.buttonType, card.buttonText, 'Order Your Way')}
                      className="bg-button text-white font-montserratSemiBold text-base leading-5 tracking-normal hover:bg-opacity-90 transition-all duration-300 focus:outline-none"
                      style={{ width: '173px', height: '44px', borderRadius: '40px' }}
                    >
                      {card.buttonText}
                    </button>
                  </CmsInlineEdit>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

OrderYourWaySection.propTypes = {
  orderYourWaySection: PropTypes.shape({
    title: PropTypes.string,
    orderCards: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.string,
      buttonText: PropTypes.string,
      buttonLink: PropTypes.string,
      buttonType: PropTypes.string,
      buttonNode: PropTypes.shape({}),
      cmsKeyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      cmsNode: PropTypes.shape({})
    })),
    cmsNode: PropTypes.shape({})
  }),
  onButtonClick: PropTypes.func.isRequired
};

OrderYourWaySection.defaultProps = {
  orderYourWaySection: null
};

export default OrderYourWaySection;

